import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "px-2" }, "Elektrooniline valve", -1)
const _hoisted_2 = {
  key: 0,
  class: "px-2 text-textDark text-justify mt-3"
}
const _hoisted_3 = { class: "text-center my-2" }
const _hoisted_4 = ["colspan"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoHoiatus = _resolveComponent("VoHoiatus")!
  const _component_VoKuvaRohkem = _resolveComponent("VoKuvaRohkem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_hidden = _resolveComponent("hidden")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_KRHPPaigutus = _resolveComponent("KRHPPaigutus")!

  return (_openBlock(), _createBlock(_component_KRHPPaigutus, null, {
    pais: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_VoHoiatus, { class: "ma-2" }),
              _hoisted_1,
              (_ctx.lehePaiseTekst && _ctx.lehePaiseTekstLuhendatud)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createVNode(_component_VoKuvaRohkem, {
                      terveTekst: _ctx.lehePaiseTekst,
                      luhendatudTekst: _ctx.lehePaiseTekstLuhendatud
                    }, null, 8, ["terveTekst", "luhendatudTekst"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_progress_circular, { indeterminate: "" })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tabelid, (tabel, i) => {
            return (_openBlock(), _createBlock(_component_v_row, { key: i }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "pt-5 pb-0 d-none d-xl-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      class: "mt-4 rounded elevation-3",
                      expanded: tabel.laiendatud,
                      "show-expand": "",
                      "fixed-header": "",
                      "single-expand": "",
                      headers: tabel.suureEkraanipaised,
                      items: [tabel.element],
                      "items-per-page": tabel.lehePikkus,
                      loading: _ctx.isLoading,
                      "row-props": _ctx.rida_class,
                      "item-key": "id"
                    }, {
                      "expanded-row": _withCtx(({ columns }) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            colspan: columns.length
                          }, [
                            _createVNode(_component_v_data_table, {
                              class: "rounded elevation-3",
                              headers: tabel.sisuPaised,
                              items: tabel.tegevused,
                              "items-per-page": tabel.lehePikkus,
                              loading: _ctx.isLoading,
                              "fixed-header": "",
                              "item-key": "id",
                              "cell-props": _ctx.item_class,
                              "row-props": _ctx.rida_class
                            }, {
                              [`item.tegevuseSisu`]: _withCtx(({ value, item }) => [
                                _createElementVNode("pre", {
                                  id: item.id,
                                  class: "pre"
                                }, _toDisplayString(value), 9, _hoisted_5),
                                _createElementVNode("input", {
                                  type: "hidden",
                                  value: _ctx.scrollToEv()
                                }, null, 8, _hoisted_6)
                              ]),
                              bottom: _withCtx(() => []),
                              _: 2
                            }, 1032, ["headers", "items", "items-per-page", "loading", "cell-props", "row-props"])
                          ], 8, _hoisted_4)
                        ])
                      ]),
                      [`item.periood`]: _withCtx(({ value }) => [
                        _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value.algusKp)) + " - " + _toDisplayString(_ctx.formateeriKuupaev(value.loppKp)), 1)
                      ]),
                      [`header.hooldusaluseKinnitamiseKp`]: _withCtx(({ }) => [
                        (tabel.element?.hooldusaluseKinnitamiseKp)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Kinnitamise kp. ")
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      [`item.hooldusaluseKinnitamiseKp`]: _withCtx(({ value, item }) => [
                        _createVNode(_component_hidden, {
                          id: item.id
                        }, null, 8, ["id"]),
                        value
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.formateeriKuupaevaAjaga(value)), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (!value && item)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              absolute: "",
                              bottom: "",
                              left: "",
                              loading: _ctx.kinnitamisedIsLoading,
                              onClick: ($event: any) => (_ctx.kinnitaEVAjakava(item)),
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Kinnitan ajakava ")
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      bottom: _withCtx(() => []),
                      _: 2
                    }, 1032, ["expanded", "headers", "items", "items-per-page", "loading", "row-props"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, { class: "d-xl-none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          class: "pt-5 pb-0",
                          cols: "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              class: "mt-4 rounded elevation-3",
                              width: "300",
                              headers: tabel.paised,
                              items: [tabel.element],
                              "items-per-page": tabel.lehePikkus,
                              loading: _ctx.isLoading,
                              "row-props": _ctx.rida_class,
                              "fixed-header": "",
                              "item-key": "id"
                            }, {
                              [`item.periood`]: _withCtx(({ value }) => [
                                _createTextVNode(_toDisplayString(_ctx.formateeriKuupaev(value.algusKp)) + " - " + _toDisplayString(_ctx.formateeriKuupaev(value.loppKp)), 1)
                              ]),
                              [`header.hooldusaluseKinnitamiseKp`]: _withCtx(({ }) => [
                                (tabel.element?.hooldusaluseKinnitamiseKp)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" Kinnitamise kp. ")
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              [`item.hooldusaluseKinnitamiseKp`]: _withCtx(({ value, item }) => [
                                _createVNode(_component_hidden, {
                                  id: item.id
                                }, null, 8, ["id"]),
                                value
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formateeriKuupaevaAjaga(value)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (!value && item)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      absolute: "",
                                      bottom: "",
                                      left: "",
                                      loading: _ctx.kinnitamisedIsLoading,
                                      onClick: ($event: any) => (_ctx.kinnitaEVAjakava(item)),
                                      color: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Kinnitan ajakava ")
                                      ]),
                                      _: 2
                                    }, 1032, ["loading", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              bottom: _withCtx(() => []),
                              _: 2
                            }, 1032, ["headers", "items", "items-per-page", "loading", "row-props"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "pb-5 pt-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              class: "rounded elevation-3",
                              headers: tabel.sisuPaised,
                              items: tabel.tegevused,
                              "items-per-page": tabel.lehePikkus,
                              loading: _ctx.isLoading,
                              "fixed-header": "",
                              "item-key": "id",
                              "cell-props": _ctx.item_class,
                              "row-props": _ctx.rida_class
                            }, {
                              [`item.tegevuseSisu`]: _withCtx(({ value, item }) => [
                                _createElementVNode("pre", {
                                  id: item.id,
                                  class: "pre"
                                }, _toDisplayString(value), 9, _hoisted_7),
                                _createElementVNode("input", {
                                  type: "hidden",
                                  value: _ctx.scrollToEv()
                                }, null, 8, _hoisted_8)
                              ]),
                              bottom: _withCtx(() => []),
                              _: 2
                            }, 1032, ["headers", "items", "items-per-page", "loading", "cell-props", "row-props"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}